import deepEqual from 'deep-equal';
import qs from 'qs';
import { useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Shape } from '@Utils/types';

export const pickAll = (search: any): any => search;

const useURLSearchTracker = <T>(
  defaultV: T,
  pick: (pickSource: qs.ParsedQs, parameters?: Shape<string | undefined>) => T = pickAll,
): [T, qs.ParsedQs] => {
  const { search } = useLocation();
  const params = useParams();
  const searchData = useMemo(() => qs.parse(search, { ignoreQueryPrefix: true }), [search]);
  const picking = useMemo(() => pick(searchData, params), [searchData, params, pick]);
  const [picked, setPicked] = useState<T>(picking || defaultV);
  const [all, setAll] = useState<qs.ParsedQs>({});

  const pickedEqual = deepEqual(picked, picking);

  if (!pickedEqual) {
    setPicked(picking);
  }

  if (!pickedEqual || !deepEqual(searchData, all)) {
    setAll(searchData);
  }

  return [picked, all];
};

export default useURLSearchTracker;
